module.exports = __webpack_public_path__ + "img/align-horizontal.e0756925.svg";